import CryptoJS from 'crypto-js';
export const getDecryptAns = (ans) => {
  const encryptedHex = ans; // Replace with actual encrypted string

  // ✅ This is the derived key from backend's scryptSync (hex string converted to WordArray)
  // console.log(SECRET_KEY.toString('hex')); from backend
  const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_MCQ_SECRET_KEY);

  // ✅ 16-byte IV = all zero bytes
  const iv = CryptoJS.enc.Hex.parse('00000000000000000000000000000000');

  // ✅ Convert encrypted string to CipherParams
  const cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.enc.Hex.parse(encryptedHex)
  });

  // ✅ Decrypt using AES
  const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  }).toString(CryptoJS.enc.Utf8);

  return decrypted || ans;
};
